import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-header text-uppercase tracking-wider text-grey-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  class: "bg-grey-1 sticky-table-columns text-left sticky--left",
  style: {"z-index":"4"}
}, "#", -1)
const _hoisted_3 = {
  key: 0,
  class: "bg-grey-1 text-bold sticky-table-columns text-left"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "bg-grey-1 text-bold sticky-table-columns text-left"
}

import { LanguageChoice } from '../../i18n'
import { ColumnsInterface, FilteringDisplayOptions } from '../../types/components/data-rendering'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTableColumnHeaders',
  props: {
    isCollapsed: { type: Boolean },
    columnLength: {},
    sortedColumn: {},
    sortedValue: { type: Boolean },
    columns: {},
    checkbox: {},
    allChecked: { type: Boolean }
  },
  emits: ["toggleSort", "setSort", "toggleAllCheckboxes"],
  setup(__props: any, { emit: __emit }) {

const { locale } = useI18n({ useScope: 'global' })
const localeString = computed(() => locale.value as LanguageChoice)

const props = __props

const emit = __emit

const sortArrow = computed(() => {
  if (props.sortedValue === null) {
    return ''
  } else if (props.sortedValue) {
    return 'las la-sort-down'
  } else {
    return 'las la-sort-up'
  }
})
const toggleSort = () => {
  emit('toggleSort')
}
const setSort = (key: string) => {
  emit('setSort', key)
}
const toggleAllCheckboxes = () => {
  emit('toggleAllCheckboxes')
}

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (!_ctx.isCollapsed)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _hoisted_2,
        (_ctx.checkbox?.checklist)
          ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
              _createVNode(_component_q_checkbox, _mergeProps({
                dense: "",
                size: "xs",
                "model-value": _ctx.allChecked,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (toggleAllCheckboxes()))
              }, _ctx.checkbox.checkProps), null, 16, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            (!column.hide)
              ? (_openBlock(), _createElementBlock("th", {
                  key: 0,
                  class: "bg-grey-1 text-bold sticky-table-columns text-left",
                  onClick: ($event: any) => (_ctx.sortedColumn === key ? toggleSort() : setSort(key)),
                  "data-test": "table-heading"
                }, [
                  _createTextVNode(_toDisplayString(column.label[localeString.value]) + " ", 1),
                  _withDirectives(_createElementVNode("i", {
                    class: _normalizeClass(sortArrow.value)
                  }, null, 2), [
                    [_vShow, _ctx.sortedColumn === key]
                  ])
                ], 8, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_ctx.$slots.itemRight)
          ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString('')))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})